// frontend/src/pages/board/components/Feeds/feedCard/AvatarSection.js
import React from "react";
import { Badge } from "@mui/material";
import Avatar from "../../../../../components/Avatar";
import { createAvtarName, hasImage } from "../../../../../utils";
import HistoryIcon from "../../../../../styles/svg/history-icon.svg";

const AvatarSection = ({ history, showIcon }) => {
  return (
    <>
      {showIcon ? (
        <Badge
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          badgeContent={<Avatar alt="History Icon" src={HistoryIcon} />}>
          <Avatar
            user_image={history?.response_object?.user_object?.user_image}
            title={history?.response_object?.user_object?.username}
            className="user-avtar-dropdown user-avatar mr-8"
            style={{
              height: "32px",
              width: "32px",
              ...(!hasImage(
                history?.response_object?.user_object?.user_image
              ) && {
                bgcolor:
                  history?.response_object?.user_object?.profile_color
                    ?.background,
                color:
                  history?.response_object?.user_object?.profile_color
                    ?.background.text,
              }),
            }}>
            {createAvtarName(
              history?.response_object?.user_object?.username || ""
            )}
          </Avatar>
        </Badge>
      ) : (
        <Avatar
          user_image={history?.response_object?.user_object?.user_image}
          title={history?.response_object?.user_object?.username}
          className="user-avtar-dropdown user-avatar mr-8"
          style={{
            height: "32px",
            width: "32px",
            ...(!hasImage(
              history?.response_object?.user_object?.user_image
            ) && {
              bgcolor:
                history?.response_object?.user_object?.profile_color
                  ?.background,
              color:
                history?.response_object?.user_object?.profile_color?.background
                  ?.text,
            }),
          }}>
          {createAvtarName(
            history?.response_object?.user_object?.username || ""
          )}
        </Avatar>
      )}
    </>
  );
};

export default React.memo(AvatarSection);
